import { BackgroundAttribute, BackgroundRepeatProp, BackgroundSizeProp } from '../types/background';
import {
  computed,
  getCurrentInstance,
  onBeforeUpdate,
  reactive,
  ref,
  toRef,
  unref,
  watch,
} from 'vue';

import backGroundHelper from '../components/background/src/helper';
import { BackgroundProps, defaultPackgroundData } from '../components/background/src/props';

const {
  composeRepeatInfo,
  concatBackgroundColor,
  concatBackgroundImage,
  IMAGE_PAVING_EFFECT,
  IMAGE_POSITION,
  IMAGE_SCALING_CONTAIN,
  IMAGE_SCALING_FILL,
  IMAGE_SCALING_STRETCH,
  parseBackgroundImageGradient,
  parseBackgroundImageUrl,
  parseRepeatInfo,
  sizeOptions,
} = backGroundHelper;

export function useBackground(props: BackgroundProps) {
  const input = ref<HTMLInputElement>();
  const { emit } = getCurrentInstance()!;

  const state = reactive<{
    cache: BackgroundAttribute | null;
    typePrivate: number;
    background: BackgroundAttribute;
    loading: boolean;
  }>({
    cache: null,
    typePrivate: -1,
    background: Object.assign(defaultPackgroundData, props.backgroundData) as BackgroundAttribute,
    loading: false,
  });

  onBeforeUpdate(() => {
    console.log('onBeforeUpdate 111...');
    if (props.backgroundData) {
      console.log('onBeforeUpdate 222...');
      state.background = props.backgroundData;
    }
  });

  const imageUrl = computed(() => {
    console.log('computed imageUrl==> %o', state.background.backgroundImage);
    return parseBackgroundImageUrl(state.background.backgroundImage) || '';
  });

  const colorForPicker = computed({
    get: () => {
      debugger;
      const color =
        parseBackgroundImageGradient(state.background.backgroundImage) ||
        props?.backgroundData?.backgroundColor ||
        '';
      console.log('colorForPicker ==> %o', color);
      return color;
    },
    set: (newVal) => {
      console.log('newVal %o', newVal);
    },
  });

  const repeatInfoComposed = computed({
    get: () => {
      const defaultOption = IMAGE_PAVING_EFFECT[0];
      const {
        backgroundRepeat = defaultOption.backgroundRepeat,
        backgroundPositionX = defaultOption.backgroundPositionX,
        backgroundPositionY = defaultOption.backgroundPositionY,
        backgroundSize = defaultOption.backgroundSize,
      } = state.background;
      return [backgroundRepeat, backgroundPositionX, backgroundPositionY, backgroundSize].join(',');
    },
    set: (newVal) => {
      handleRepeatChange(newVal);
    },
  });

  // 平铺效果数据集
  const pavingEffectList = computed(() => {
    const pavingList = IMAGE_PAVING_EFFECT.filter(
      ({ backgroundSize }) => backgroundSize && sizeOptions.indexOf(backgroundSize) > -1,
    ).map((item) => ({
      value: composeRepeatInfo(item as Partial<BackgroundAttribute>),
      label: item.label,
      type: item.key,
    }));

    console.log('pavingList ===> %o', pavingList);

    return pavingList;
  });

  // 平铺效果数据
  const pavingEffectInfos = computed(() => {
    return IMAGE_PAVING_EFFECT.filter(
      ({ backgroundSize }) => backgroundSize && sizeOptions.indexOf(backgroundSize) > -1,
    ).map((item) => composeRepeatInfo(item as Partial<BackgroundAttribute>));
  });

  // 是否是平铺
  const isOnPavingEffect = computed(() => {
    console.log(
      'pavingEffectInfos=%o, repeatInfoComposed=%o',
      pavingEffectInfos.value,
      repeatInfoComposed.value,
    );
    return unref(pavingEffectInfos)?.indexOf(unref(repeatInfoComposed)) > -1;
  });

  // 是否显示图片位置
  const isOnImagePosition = computed(() => {
    console.log(
      'imagePositionInfos=%o, repeatInfoComposed=%o',
      imagePositionInfos.value,
      repeatInfoComposed.value,
    );
    return unref(imagePositionInfos)?.indexOf(unref(repeatInfoComposed)) > -1;
  });

  // 图片位置数据
  const imagePositionInfos = computed(() => {
    return IMAGE_POSITION.filter(
      ({ backgroundSize }) => backgroundSize && sizeOptions.indexOf(backgroundSize) > -1,
    ).map((item) => composeRepeatInfo(item as Partial<BackgroundAttribute>));
  });

  // 图片拉伸数据
  const stretchInfos = computed(() => {
    return IMAGE_SCALING_STRETCH.filter(
      ({ backgroundSize }) => backgroundSize && sizeOptions.indexOf(backgroundSize) > -1,
    ).map((item) => composeRepeatInfo(item as Partial<BackgroundAttribute>));
  });

  // 是否展示拉升
  const isOnStretch = computed(() => {
    return unref(stretchInfos).indexOf(unref(repeatInfoComposed)) > -1;
  });

  // 图片填充数据
  const fillInfos = computed(() => {
    return IMAGE_SCALING_FILL.filter(
      ({ backgroundSize }) => backgroundSize && sizeOptions.indexOf(backgroundSize) > -1,
    ).map((item) => composeRepeatInfo(item as Partial<BackgroundAttribute>));
  });

  // 等比例 信息
  const containInfos = computed(() => {
    return IMAGE_SCALING_CONTAIN.filter(
      ({ backgroundSize }) => backgroundSize && sizeOptions.indexOf(backgroundSize) > -1,
    ).map((item) => composeRepeatInfo(item as Partial<BackgroundAttribute>));
  });

  // 是否是填充
  const isOnFill = computed(() => {
    return unref(fillInfos).indexOf(repeatInfoComposed.value) > -1;
  });

  // 是否是等比例
  const isOnContain = computed(() => {
    return unref(containInfos).indexOf(repeatInfoComposed.value) > -1;
  });

  const backgroundAttachment = computed(() => {
    const { backgroundAttachment = 'scroll' } = state.background;
    return backgroundAttachment;
  });

  const opacityForSlider = computed({
    get: () => {
      const { opacity = 1 } = state.background;
      return parseFloat((opacity * 100).toFixed(0));
    },
    set: (newVal) => {
      handleOpacityChange(newVal);
    },
  });

  const imageScaling = computed({
    get: () => {
      return isOnPavingEffect.value
        ? 0
        : isOnImagePosition.value
        ? 1
        : isOnStretch.value
        ? 2
        : isOnFill.value
        ? 3
        : isOnContain.value
        ? 4
        : -1;
    },
    set: (newVal) => {
      console.log('start scaling ....');
      handleImageScalingChange(newVal);
      console.log('end scaling ....');
    },
  });

  const shouldRenderAttachment = computed(() => {
    return imageUrl.value && props.useAttachment && isSupportAttachment(state.background);
  });

  function isSupportAttachment({
    backgroundRepeat,
    backgroundSize,
  }: {
    backgroundRepeat: BackgroundRepeatProp;
    backgroundSize: BackgroundSizeProp;
  }) {
    return (
      backgroundRepeat &&
      backgroundRepeat !== 'repeat' &&
      backgroundSize &&
      backgroundSize === 'auto'
    );
  }

  const shouldRenderOpacity = computed(() => {
    const { opacity = 1 } = state.background;
    return imageUrl.value && opacity >= 0;
  });

  const backgroundType = computed({
    get() {
      return imageUrl.value ? 1 : state.typePrivate > -1 ? state.typePrivate : 0;
    },
    set(newVal) {
      state.typePrivate = newVal;
      if (newVal === 0) {
        state.cache = { ...state.background };
        const currentValue = {
          backgroundColor: concatBackgroundColor(colorForPicker.value),
          backgroundImage: concatBackgroundImage('', colorForPicker.value),
        };
        //emit('update:modelValue', currentValue);
        emit('typeChange', currentValue);
      } else if (state.cache) {
        const currentValue = {
          ...state.cache,
          backgroundColor: concatBackgroundColor(colorForPicker.value),
          backgroundImage: concatBackgroundImage(
            parseBackgroundImageUrl(state.cache.backgroundImage),
            colorForPicker.value,
          ),
        };
        //emit('update:modelValue', currentValue);
        emit('typeChange', currentValue);
      }
    },
  });

  function handleDel() {
    const currentValue = {
      backgroundColor: concatBackgroundColor(colorForPicker.value),
      backgroundImage: concatBackgroundImage('', colorForPicker.value),
    };
    // emit('update:modelValue', currentValue);
    emit('imageChange', currentValue);
    if (state.typePrivate === -1) {
      state.typePrivate = 1;
    }
  }

  function getCurrentValueByColor(color: string) {
    return {
      ...state.background,
      backgroundColor: concatBackgroundColor(color),
      backgroundImage: concatBackgroundImage(imageUrl.value, color),
    };
  }

  function handleColorInput(color: string) {
    const currentValue = getCurrentValueByColor(color);
    // emit('update:modelValue', currentValue);
    emit('colorChanging', currentValue);
  }

  function handleColorChangeStop(color: string) {
    const currentValue = getCurrentValueByColor(color);
    // emit('update:modelValue', currentValue);
    emit('colorChange', currentValue);
  }

  function handleThemeColorClick(themeColor: string) {
    console.log('handleThemeColorClick ===========>%o', themeColor);
    emit('colorChanging', themeColor);
  }

  function handleJump() {
    if (props.linkJump) {
      props.linkJump();
    } else {
      window.open(imageUrl.value);
    }
  }

  function handleFileUpload() {
    if (props.fileUpload) {
      props.fileUpload();
    } else {
      const inputEl = input.value;
      if (inputEl) {
        inputEl.value = '';
        inputEl.click();
      }
    }
  }

  function handleFileChange() {
    // const { files } = ev.target;
    // if (!files) return;

    // const imageUrl = URL.createObjectURL(files[0]);

    const imageUrl =
      `url('https://1.s140i.faiscm.com/2/AIwBCAAQAhgAIJn17NUFKKCYhZkFMIAPOIAK.jpg')` || '';

    const [backgroundRepeat, backgroundPositionX, backgroundPositionY, backgroundSize] =
      parseRepeatInfo(repeatInfoComposed.value);

    const currentValue = {
      ...state.background,
      backgroundRepeat,
      backgroundPositionX,
      backgroundPositionY,
      backgroundSize,
      backgroundImage: concatBackgroundImage(imageUrl, colorForPicker.value),
    };
    // emit('update:modelValue', currentValue);
    emit('imageChange', currentValue);
  }

  function handleImageScalingChange(newVal: number) {
    let currentRepeatInfoComposed = '';
    switch (newVal) {
      case 0:
        currentRepeatInfoComposed = unref(pavingEffectInfos)[0];
        break;
      case 1:
        currentRepeatInfoComposed = unref(imagePositionInfos)[4];
        break;
      case 2:
        currentRepeatInfoComposed = unref(stretchInfos)[0];
        break;
      case 3:
        currentRepeatInfoComposed = unref(fillInfos)[0];
        break;
      case 4:
        currentRepeatInfoComposed = unref(containInfos)[0];
        break;
      case 5:
        currentRepeatInfoComposed = composeRepeatInfo({
          backgroundRepeat: '',
          backgroundPositionX: '',
          backgroundPositionY: '',
          backgroundSize: '',
        });
        break;
    }

    console.log('get currentRepeatInfoComposed info ....');

    if (currentRepeatInfoComposed) {
      const [backgroundRepeat, backgroundPositionX, backgroundPositionY, backgroundSize] =
        parseRepeatInfo(currentRepeatInfoComposed);

      console.log('parseRepeatInfo info ....');

      const currentValue = {
        ...state.background,
        backgroundAttachment: isSupportAttachment({
          backgroundRepeat,
          backgroundSize,
        })
          ? state.background.backgroundAttachment || 'scroll'
          : '',
        backgroundRepeat,
        backgroundPositionX,
        backgroundPositionY,
        backgroundSize,
      };

      console.log('merge info ....');
      // emit('update:modelValue', currentValue);
      emit('scaleChange', currentValue);
    }
  }

  function handleRepeatChange(newVal: string) {
    const [backgroundRepeat, backgroundPositionX, backgroundPositionY, backgroundSize] =
      parseRepeatInfo(newVal);

    const currentValue = {
      ...state.background,
      backgroundAttachment: isSupportAttachment({
        backgroundRepeat,
        backgroundSize,
      })
        ? state.background.backgroundAttachment || 'scroll'
        : '',
      backgroundRepeat,
      backgroundPositionX,
      backgroundPositionY,
      backgroundSize,
    };
    // emit('update:modelValue', currentValue);
    emit('repeatChange', currentValue);
  }

  function handleBackgroundAttachmentChange(val: any) {
    const currentValue = {
      ...state.background,
      backgroundAttachment: val,
    };
    emit('input', currentValue);
    emit('attachmentChange', currentValue);
  }

  function handleOpacityChange(newVal: any) {
    const opacity = parseFloat((newVal / 100).toFixed(2));
    state.background.opacity = opacity;
    emit('opacityChanging', state.background);
  }

  function handleOpacityChangeStop(newVal: any) {
    const opacity = parseFloat((newVal / 100).toFixed(2));
    state.background.opacity = opacity;
    emit('opacityChange', state.background);
  }

  function transformInfos(options: Partial<BackgroundAttribute>[]) {
    return options
      .filter(({ backgroundSize }) => backgroundSize && sizeOptions.indexOf(backgroundSize) > -1)
      .map(composeRepeatInfo);
  }

  function handleBeforeUpload() {
    // const { size, name } = file;
    // 生成图片缩略图
    // if (checkImgType(file)) {
    //   // beforeUpload，如果异步会调用自带上传方法
    //   // file.thumbUrl = await getBase64(file);
    //   // getBase64WithFile(file).then(({ result: thumbUrl }) => {
    //   //   state.background.backgroundImage = thumbUrl;
    //   // });
    //
    //   // const url = useObjectUrl(file);
    //   state.background.backgroundImage =
    //     `url('https://1.s140i.faiscm.com/2/AIwBCAAQAhgAIJn17NUFKKCYhZkFMIAPOIAK.jpg')` || '';
    // }
    // state.background.backgroundImage =
    //   `url('https://1.s140i.faiscm.com/2/AIwBCAAQAhgAIJn17NUFKKCYhZkFMIAPOIAK.jpg')` || '';
    handleFileUpload();
    return false;
  }

  watch(
    () => imageUrl,
    () => {
      /* 在下拉面板中，改变url导致面板宽度改变时, 通知下拉面板更新 */
      emit('dropdownPanelUpdate');
    },
  );

  return {
    loading: toRef(state, 'loading'),
    imageUrl,
    imageScaling,
    shouldRenderAttachment,
    shouldRenderOpacity,
    backgroundType,
    handleDel,
    handleColorInput,
    handleColorChangeStop,
    handleThemeColorClick,
    handleJump,
    handleFileUpload,
    handleFileChange,
    handleImageScalingChange,
    handleRepeatChange,
    handleBackgroundAttachmentChange,
    handleOpacityChange,
    handleOpacityChangeStop,
    transformInfos,
    isOnPavingEffect,
    repeatInfoComposed,
    pavingEffectList,
    isOnImagePosition,
    imagePositionInfos,
    colorForPicker,
    backgroundAttachment,
    opacityForSlider,
    handleBeforeUpload,
  };
}
